<template>
  <i v-if="isInline" v-html="svgContent" :class="customClass" />
  <img v-else :src="imgSrc" :class="customClass" />
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    src: {
      type: [String, Object],
      required: true,
    },
    inline: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: "svg-icon",
    },
  },
  computed: {
    svgString() {
      // 支持 src 为 svg 字符串、模块对象（raw-loader导入）或普通图片路径
      if (typeof this.src === "string") return this.src;
      if (this.src && typeof this.src === "object") {
        // raw-loader导入的svg模块通常有default属性
        if (typeof this.src.default === "string") return this.src.default;
        // vite/webpack可能直接导出字符串
        if (typeof this.src.svg === "string") return this.src.svg;
      }
      return "";
    },
    isInline() {
      // 判断是否为svg字符串（以<svg开头）
      return (
        this.inline &&
        typeof this.svgString === "string" &&
        this.svgString.trim().startsWith("<svg")
      );
    },
    svgContent() {
      return this.isInline ? this.svgString : "";
    },
    imgSrc() {
      // 如果不是svg字符串，则作为图片路径
      if (!this.isInline) {
        if (typeof this.src === "string") return this.src;
        if (this.src && typeof this.src === "object") {
          if (typeof this.src.default === "string") return this.src.default;
          if (typeof this.src.svg === "string") return this.src.svg;
        }
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
.svg-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
</style>
